export type Option = {
    name: string;
    value: string;
};

export enum ResidencyType {
    RentedOnePerson = "RentedOnePerson",
    RentedTwoPeople = "RentedTwoPeople",
    RentedThreePeople = "RentedThreePeople",
    RentedFourPeople = "RentedFourPeople",
    RentedFivePeople = "RentedFivePeople",
    RentedSixPeople = "RentedSixPeople",
    RentedSevenPeople = "RentedSevenPeople",
    RentedEightPeople = "RentedEightPeople",
    RentedNinePeople = "RentedNinePeople",
    RentedTenPeople = "RentedTenPeople"
}

export enum ResidencyOwnershipStatus {
    OwnerOccupied = "OwnerOccupied",
    IsLandlord = "IsLandlord",
    IsNotLandlord = "IsNotLandlord",
    IsHolidayHome = "IsHolidayHome",
    UnderRenovation = "UnderRenovation",
    Unoccupied = "Unoccupied"
}

export enum RentalStatus {
    RentedFamily = "RentedFamily",
    RentedCouple = "RentedCouple",
    RentedStudents = "RentedStudents",
    IndividualTenants = "IndividualTenants"
}

export enum HolidayHomeUse {
    HolidayHomeLetOut = "HolidayHomeLetOut",
    HolidayHomeFamilyUse = "HolidayHomeFamilyUse"
}

export enum AlarmType {
    Monitored = "NSAIApprovedInstallerAlarmStandardToCentralStation",
    Unmonitored = "NSAIApprovedInstallerAlarmStandard",
    None = "None"
}

export const ResidencyOptions = { ...ResidencyType, ...ResidencyOwnershipStatus, ...RentalStatus, ...HolidayHomeUse };
export type ResidencyOptions = ResidencyType | ResidencyOwnershipStatus | RentalStatus | HolidayHomeUse;
